import { dataTypes } from '@adalo/constants'
import { evaluateCondition } from './conditions'

export const empty = itm => {
  return [null, undefined, ''].includes(itm)
}

export const getDataType = (filter, data, comparison, opts) => {
  let { fieldId } = filter

  if (fieldId && fieldId.source) {
    return fieldId.source.dataType
  }

  if (!data || data.length === 0) {
    return null
  }

  let { datasourceId, tableId } = data[0]._meta

  let app = opts.getApp()

  let datasource = app.datasources[datasourceId]
  let table = datasource && datasource.tables[tableId]

  let field = table && table.fields[fieldId]

  return (field && field.type) || dataTypes.TEXT
}

export const applyFilter = (data, filters, getBindingValue, opts) => {
  if (!filters) {
    return data
  }
  if (!Array.isArray(filters)) {
    filters = [filters]
  }

  filters.forEach(filter => {
    if (!filter || !filter.fieldId) {
      return
    }

    let comparison = getBindingValue(filter.comparison)
    let comparison2 = getBindingValue(filter.comparison2)

    let dataType = getDataType(filter, data, filter.comparison, opts)

    let { fieldId } = filter
    let getter = () => null

    if (typeof fieldId === 'string') {
      getter = itm => itm[fieldId]
    } else {
      getter = itm => {
        let getBinding = listObjectId => {
          return itm
        }

        return getBindingValue(fieldId, { getBinding })
      }
    }

    data = applyFilterSub(
      data,
      dataType,
      getter,
      filter.comparator,
      comparison,
      comparison2
    )
  })

  return data
}

const applyFilterSub = (
  data,
  dataType,
  getter,
  comparator,
  comparison,
  comparison2
) => {
  if (!data || !Array.isArray(data)) {
    return data
  }

  let result = data.filter(row => {
    let itm = getter(row)

    try {
      return evaluateCondition(
        itm,
        comparator,
        dataType,
        comparison,
        comparison2
      )
    } catch (err) {
      console.error('filter error:', err)

      return false
    }
  })

  return result
}
